export class admCatDocumentsGrid {
}